
// A function to generate a key based on the value and change labels in an array of objects.


export function changeLabel(arr, translateName, translateFunc) {
	return arr && arr.map((item) => {
		if(!item?.value || !item?.label) {
			return item
		}
		return {
			...item,
			label: translateFunc(`${translateName}_${item.value}`)
		}
		
	})
}

export const isRouteDisabled = (rights, id) => {
	const includesRights = rights?.find(e => e[0] === id)
	return rights?.length && includesRights && includesRights?.[1] === '0'
}